export const NAVIGATE = 'Navigate';